import React from "react";
import { TextField, CircularProgress, useTheme } from "@mui/material";

const CustomTextField = ({ label, value, onChange, disabled = false, loading = false, type = "text", fullWidth = true, placeholder, ...props }) => {
  const theme = useTheme();

  const textFieldStyle = {
    backgroundColor: disabled ? "#f1f1f1" : "#fff",
    fontWeight: "bold",
    color: "#000",
    fontSize: 12,
    mb: 2,
    "& .MuiFormLabel-root": {
      color: "#000",
    },
    "& .MuiInputBase-input": {
      fontWeight: "bold",
      opacity: 1,
      color: "#000",
      WebkitTextFillColor: "#000",
      "&::placeholder": {
        color: theme.bandera?.colorSecundario || "#004280",
        opacity: 1,
      },
    },
    ...props.sx,
  };

  return (
    <TextField
      label={label}
      placeholder={placeholder}
      value={value || ""}
      onChange={onChange}
      type={type}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      sx={textFieldStyle}
      InputProps={{
        endAdornment: loading ? <CircularProgress size={20} /> : null,
        ...props.InputProps,
      }}
      {...props}
    />
  );
};

export default CustomTextField;
